import { useCallback } from 'react';
import debounce from 'lodash/debounce';

export function useDebounce(fn, wait = 0, options = {}) {
  return useCallback(debounce(fn, wait, options), [debounce]);
}
